// @flow

import React from 'react';
import {
  Segment,
  Form,
  Checkbox,
  Input,
  Grid,
  Button,
  Icon,
  Divider,
} from 'semantic-ui-react';

type Props = {
  search: ?string,
  unread: boolean,
  tracked: boolean,
  onCreateThread: () => void,
  onSearchChanged: (value: string) => void,
  onUnreadChanged: (value: boolean) => void,
  onTrackedChanged: (value: boolean) => void,
};

export const Filter = ({
  search,
  unread,
  tracked,
  onCreateThread,
  onSearchChanged,
  onUnreadChanged,
  onTrackedChanged,
}: Props) => {
  const searchChanged = event => onSearchChanged(event.target.value);
  const checkboxChanged = thunk => (_, { checked }) => thunk(checked);

  return (
    <Segment clearing>
      <div className="ui form">
        <Grid>
          <Grid.Column mobile={16} tablet={12} computer={12}>
            <Form.Field>
              <Checkbox
                label="Message(s) non lu(s)"
                checked={unread}
                onChange={checkboxChanged(onUnreadChanged)}
              />
            </Form.Field>
            <Form.Field>
              <Checkbox
                label="Conversation(s) suivie(s)"
                checked={tracked}
                onChange={checkboxChanged(onTrackedChanged)}
              />
            </Form.Field>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={4} computer={4} textAlign="right">
            <Button
              type="button"
              icon
              primary
              fluid
              labelPosition="left"
              onClick={onCreateThread}
            >
              Nouvelle conversation
              <Icon name="plus" />
            </Button>
          </Grid.Column>
        </Grid>
        <Divider hidden />
        <Form.Field>
          <Input
            icon="search"
            placeholder="Rechercher..."
            value={search || ''}
            onChange={searchChanged}
          />
        </Form.Field>
      </div>
    </Segment>
  );
};



// WEBPACK FOOTER //
// ./src/modules/messaging/components/threads/Filter.js